<template>
  <div class="mine page">
    <div class="bg-container page-bg">
      <div class="bg-wrapper"></div>
    </div>
    <div class="wrapper">
      <div class="van-pull-refresh">
        <div class="van-pull-refresh__track" style="transition-duration: 0ms;">
          <div class="van-pull-refresh__head"></div>
          <div class="header">
            <div class="nav-bar van-nav-bar van-hairline--bottom">
              <div class="van-nav-bar__content">
                <div class="van-nav-bar__left">
                  <i class="van-icon van-icon-setting-o" @click="showSetting" style="color: rgb(255, 255, 255);"></i></div>
                <div class="van-nav-bar__title van-ellipsis"></div>
                <div class="van-nav-bar__right"><img src="img/mine/logout.svg" @click="loginout" alt=""></div>
              </div>
            </div>
            <div class="user-wrapper">
              <div class="user_img van-image van-image--round">
                <img class="van-image__img" :src="userInfo.header_img?userInfo.header_img:'/img/mine/avatar.png'">
              </div>
              <div class="login-content">
                <p class="login-btn">
                  {{this.userInfo.username}} <span style="margin-left: 10px;color: #666">{{this.userInfo.lv}}</span>
                </p>
                <p class="login-label">
                <div class="van-progress" style="height: 8px;">
                  <span class="van-progress__portion" :style="'background: linear-gradient(270deg, rgb(230, 195, 161), rgb(248, 113, 113)); width:' +(userInfo.total_recharge/userInfo.nextP)*100+'%'"></span>
                </div>
              </div>
            </div>
          </div>
          <div class="content">
            <div class="finance">
              <div class="finance-item" @click="doPay()">
                <img src="img/mine/recharge.svg" alt="" class="icon">
                <span class="text">{{ $t("mine.recharge") }}</span>
              </div>
              <div class="line"></div>
              <div class="finance-item" @click="doWithdrawal()">
                <img src="img/mine/withdraw.svg" alt="" class="icon">
                <span class="text">{{ $t("mine.withdraw") }}</span>
              </div>
            </div>
            <div class="wallet">
              <div class="part-1 van-hairline--bottom">
                <p class="flex-1 font-28 font-primary-color">
                  {{ $t("mine.balance") }}</p>
                <button class="refresh-btn van-button van-button--primary van-button--normal" @click="$router.push({path:'/Moneylog'});">
                  <div class="van-button__content">
                    <span class="van-button__text">{{ $t("mine.detail") }}</span>
                  </div>
                </button>
              </div>
              <div class="part-2"><p class="balance van-ellipsis">{{userInfo.money}}</p><span
                  class="font-28 font-gray">{{ this.$store.getters.getBaseInfo.currency }}</span></div>
              <div class="part-2"><p class="balance van-ellipsis">{{userInfo.credit_score}}</p><span
                  class="font-28 font-gray">{{ $t("mine.score") }}</span></div>
            </div>
            <div class="menu" style="margin-top: 15px;">
              <div class="menu-item" @click="$router.push({path:'/Personalreport'});">
                <div class="menu-item-icon van-image">
                  <img src="img/mine/baobiao.svg" class="van-image__img"></div>
                <span class="menu-item-label">{{ $t("mine.finance") }}</span>
              </div>
              <div class="menu-item"  @click="$router.push({path:'/Moneylog'});">
                <div class="menu-item-icon van-image">
                  <img src="img/mine/mingxi.svg" class="van-image__img"></div>
                <span class="menu-item-label">{{ $t("mine.order") }}</span>
              </div>
              <div class="menu-item" @click="$router.push({path:'/GameRecord'});">
                <div class="menu-item-icon van-image">
                  <img src="img/mine/youxi.svg" class="van-image__img"></div>
                <span class="menu-item-label">{{ $t("mine.record") }}</span>
              </div>
              <div class="menu-item" @click="showSetting">
                <div class="menu-item-icon van-image">
                  <img src="img/mine/user.svg" class="van-image__img"></div>
                <span class="menu-item-label">{{ $t("mine.my") }}</span></div>
              <div class="menu-item" @click="toNotice">
                <div class="menu-item-icon van-image">
                  <img src="img/mine/gonggao.svg" class="van-image__img"></div>
                <span class="menu-item-label">{{ $t("mine.notice") }}</span></div>
              <div class="menu-item" @click="toService">
                <div class="menu-item-icon van-image">
                  <img src="img/mine/kefu_1.svg" class="van-image__img"></div>
                <span class="menu-item-label">{{ $t("mine.service") }}</span></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      userInfo: {},
      mail: 0,
      menu_top: 40,
      isLoading: false,
    };
  },
  methods: {
    refresh() {
      this.isLoading = true;
      setTimeout(() => {
        this.isLoading = false;
        if (localStorage.getItem('token')) {
          this.$toast(this.$t("msg.刷新成功！"));
        } else {
          this.$router.push({path: '/Login'})
        }
      }, 500);
    },
    exit() {
      this.$toast(this.$t("msg.请完成任务单后进入"));
    },
    toPayPassword() {
      this.$router.push({path: '/SetPayPassword'});
      /*if(this.userInfo.paypassword !== "未设置"){
        this.$toast(this.$t("msg.提现密码已设置，需要修改请联系客服"));
      }else {
      }*/
    },

    loginout() {
      localStorage.clear();
      localStorage.setItem('lang', this.lang);
      this.$router.push({path: '/Login'});
    },
    toLoginPassword() {
      this.$router.push({path: '/SetLoginPassword'});
    },
    showSetting() {
      if (localStorage.getItem('token')) {
        this.$router.push({path: '/Setting'})
      } else {
        this.$router.push({path: '/Login'})
      }
    },
    toNotice() {
      if (localStorage.getItem('token')) {
        this.$router.push({path: '/Notice'})
      } else {
        this.$router.push({path: '/Login'})
      }
    },
    onRefresh() {
      setTimeout(() => {
        this.isLoading = false;
        if (localStorage.getItem('token')) {
          this.getUserInfo();
          this.$toast(this.$t("msg.刷新成功！"));
        } else {
          this.$router.push({path: '/Login'})
        }
      }, 500);
    },
    doLogin() {
      if (localStorage.getItem('token')) {
        this.$router.push({path: '/Infomation'});
      } else {
        this.$router.push({path: '/Login'})
      }
    },
    doPay() {
      this.$toast(this.$t("msg.请联系客服充值"));
      return false;
    },
    doWithdrawal() {

      this.$router.push("withdraw");
      /*this.$http({
        method: 'get',
        url: 'user_get_bank',
      }).then(res => {
        if (res.data.is_bank) {
          this.$router.push("withdraw");
        } else {
          this.$router.push("Setbank");
          this.$toast(this.$t("msg.请设置收款卡!"));
        }
      })*/
    },
    toMail() {
      if (localStorage.getItem('token')) {
        this.$router.push({path: '/Mail'})
      } else {
        this.$router.push({path: '/Login'})
      }
    },
    toService() {
      if (this.$store.getters.getBaseInfo.iskefu == 1) {
        this.$router.push("ServiceOnline");
      } else {
        this.$toast(this.$t("msg.功能已禁用!"));
      }
    },
    getUserInfo() {
      this.$http({
        method: 'get',
        url: 'user_info'
      }).then(res => {
        if (res.code === 200) {
          this.userInfo = res.data;
          this.menu_top = 15;
          this.mail = res.data.mail;
          if (this.userInfo.status !== 1) {
            this.$toast(this.$t("msg.账号下线"));
            localStorage.clear()
            this.$router.push({path: '/Login'})
          }
        } else if (res.code === 401) {
          //this.$toast(res.msg);
        }
      })
    },
  },
  created() {
    if (!localStorage.getItem('token')) {
      this.$router.push({path: '/Login'})
    } else {
      this.getUserInfo();
    }
  }
};
</script>

<style scoped>
.mine {
  position: relative;
  bottom: 1.333vw;
  background: #f2f2f5
}

.mine .wrapper {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  padding-bottom: 24vw
}

.mine .header,.nav-bar {
  background: linear-gradient(90deg,#525ee9,#b077d6,#4b1d79)
}

.mine .header {
  padding-bottom: 13.333vw
}
.mine .wrapper .content .wallet {
  width: 100%;
}
</style>
